import { useEffect, useState } from 'react';

export const useShowMore = <T>(items: T[], end: number, listKey?: string) => {
  const [displayedItems, setDisplayedItems] = useState<T[]>([]);
  const [currentEnd, setCurrentEnd] = useState(end);

  const getMore = () => {
    const newEnd = currentEnd + end;
    setDisplayedItems(items.slice(0, newEnd));
    setCurrentEnd(newEnd);

    if (listKey) {
      const clicks = sessionStorage.getItem(`showMore_${listKey}`);
      const currentClicks = clicks ? parseInt(clicks) : 0;
      sessionStorage.setItem(
        `showMore_${listKey}`,
        (currentClicks + 1).toString(),
      );
    }
  };

  useEffect(() => {
    if (listKey) {
      const clicks = sessionStorage.getItem(`showMore_${listKey}`);
      const storedClicks = clicks ? parseInt(clicks) : 0;
      const initialEnd = end + storedClicks * end;
      setDisplayedItems(items.slice(0, initialEnd));
      setCurrentEnd(initialEnd);
    } else {
      setDisplayedItems(items.slice(0, end));
      setCurrentEnd(end);
    }
  }, [items, end, listKey]);

  const allShown = currentEnd >= items.length;

  return { getMore, items: displayedItems, allShown };
};
